import React from 'react';

// The SAME dialog Guide's tables use (operator decision 2026-08-18): reused,
// not imitated — one component to restyle when the app's delete treatment
// changes. Only the consequence sentence is ours, via the `message` prop added
// for exactly this reuse.
//
// TODO(design-system): deviation from the module's DS-only rule, by operator
// instruction. The shared modal stack has no focus trap and no Escape-to-close
// (the DS Dialog has both); if DeleteProjectModal ever moves onto the DS
// Dialog, this adapter inherits the fix for free.
import DeleteProjectModal from 'Pages/GMS/ISR/Components/DeleteProjectModal';

// Constants
import { STRINGS } from '../../constants';

interface DeleteCardDialogProps {
  isOpen: boolean;
  cardName: string;
  /** True while the DELETE request is in flight: confirm disables and reads
   *  "Deleting…", and cancelling (button, backdrop) is ignored so the dialog
   *  reports the outcome of the request it started. */
  isDeleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Delete confirmation. Deletes nothing until the user confirms; cancelling
 * leaves the card exactly as it was (spec R24, R26, R27). The card's name
 * renders in the title ("Delete {name}?"), Guide-style; the warning sentence
 * is static and card-correct, so a hostile card name can restyle the heading
 * but never rewrite the warning.
 */
const DeleteCardDialog = ({
  isOpen,
  cardName,
  isDeleting = false,
  onCancel,
  onConfirm,
}: DeleteCardDialogProps) => (
  <DeleteProjectModal
    id="product-cards-delete-modal"
    showModal={isOpen}
    closeModal={() => {
      if (!isDeleting) {
        onCancel();
      }
    }}
    onConfirm={onConfirm}
    loading={isDeleting}
    loadingText={STRINGS.deleteDialog.deleting}
    deleteItem={{ name: cardName }}
    message={STRINGS.deleteDialog.warning}
  />
);

export default DeleteCardDialog;
